// Canonical guard for user/author-supplied URLs that reach href/src or
// window.open — only http(s) may pass (a javascript:/data: entry would be
// stored XSS). Shared by v3 and v4 surfaces; do not fork per-page copies.

/** True only for strings that parse as http:/https: (relative URLs resolve
 *  against the current origin and pass). */
export const isSafeHttpUrl = (url: unknown): url is string => {
  if (typeof url !== 'string' || url === '') return false;
  try {
    const { protocol } = new URL(url, window.location.origin);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
};

/** Open a user-supplied URL in a new tab — no-op unless it passes
 *  `isSafeHttpUrl`; always severs `window.opener` (reverse-tabnabbing). */
export const openExternalUrlSafely = (url: unknown): void => {
  if (!isSafeHttpUrl(url)) return;
  window.open(url, '_blank', 'noopener,noreferrer');
};
